import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { NFeEntradaTagService } from '../../../../../shared/services/apis/repo-dfe/nfe-entrada-tag.service';
import { AcaoTagsNFeEntradaEnum } from '../../../../../shared/enums/repo-dfe/acao-tags-nfe-entrada.enum';
import { TagNFeEntrada } from '../../../../../shared/services/models/repo-dfe/tag-nfe-entrada.model';
import { NFeEntradaAlterarTagsRequest } from '../../../../../shared/services/requests/repo-dfe/nfe-entrada-alterar-tags.request';
import { AlterarTagsNotaFiscalEntradaDialogData } from './alterar-tags-nota-fiscal-entrada-dialog-data';

@Component({
  selector: 'app-alterar-tags-nota-fiscal-entrada-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressSpinnerModule, MatSelectModule],
  templateUrl: './alterar-tags-nota-fiscal-entrada-dialog.component.html',
  styleUrls: ['./alterar-tags-nota-fiscal-entrada-dialog.component.css'],
})
export class AlterarTagsNotaFiscalEntradaDialogComponent implements OnInit {
  public readonly acaoTags = AcaoTagsNFeEntradaEnum;
  public modo = AcaoTagsNFeEntradaEnum.Incluir;
  public pesquisa = '';
  public tagsFiltradas: TagNFeEntrada[] = [];
  public tagsSelecionadas = new Set<number>();
  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<AlterarTagsNotaFiscalEntradaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlterarTagsNotaFiscalEntradaDialogData,
    private nfeEntradaTagService: NFeEntradaTagService,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
    this.tagsFiltradas = [...this.data.tags];
    this.tagsSelecionadas = new Set(this.data.idsTagsAtuais);
  }

  get podeAplicar(): boolean { return !this.isLoading && this.tagsSelecionadas.size > 0; }

  public filtrarTags(): void {
    const pesquisa = this.pesquisa.trim().toLocaleLowerCase();
    this.tagsFiltradas = pesquisa ? this.data.tags.filter(tag => tag.descricao.toLocaleLowerCase().includes(pesquisa)) : [...this.data.tags];
  }

  public alternarTag(idTag: number): void {
    if (this.tagsSelecionadas.has(idTag)) this.tagsSelecionadas.delete(idTag);
    else this.tagsSelecionadas.add(idTag);
  }

  public alterarModo(): void { this.tagsSelecionadas.clear(); }

  public isTagSelecionada(idTagNFeEntrada: number): boolean {
    return this.tagsSelecionadas.has(idTagNFeEntrada);
  }

  public get contadorText(): string {
    const quantidade = this.tagsSelecionadas.size;
    return quantidade === 1 ? '1 tag selecionada' : `${quantidade} tags selecionadas`;
  }

  public get helpText(): string {
    return this.modo === AcaoTagsNFeEntradaEnum.Incluir
      ? 'As tags selecionadas serão adicionadas, mantendo as existentes.'
      : 'As tags selecionadas serão removidas, mantendo as demais existentes.';
  }

  public salvar(): void {
    if (!this.podeAplicar) return;
    this.isLoading = true;
    const request: NFeEntradaAlterarTagsRequest = {
      idsNFeEntrada: this.data.idsNFeEntrada,
      idsTags: [...this.tagsSelecionadas],
      acao: this.modo,
    };
    this.nfeEntradaTagService.alterarTags(request).subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) { this.alertService.show('Erro', response.errorDescription, AlertType.error); return; }
        const mensagem = this.modo === AcaoTagsNFeEntradaEnum.Incluir ? 'Tags incluídas com sucesso!' : 'Tags removidas com sucesso!';
        this.alertService.show('Sucesso', mensagem, AlertType.success);
        this.dialogRef.close({ success: true });
      },
      error: () => { this.isLoading = false; this.alertService.show('Erro', 'Não foi possível atualizar as tags.', AlertType.error); },
    });
  }

  public fechar(): void { this.dialogRef.close(); }
}
